import { render, staticRenderFns } from "./ag-currency-input.vue?vue&type=template&id=0c2be76e"
import script from "./ag-currency-input.vue?vue&type=script&lang=js"
export * from "./ag-currency-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports